import styles from './percentField.module.css'
import { InputGroup } from '../input-group/inputGroup'
import { TextOrNumber } from '../../types'
import { O } from '../../../state/types'

type Props = {
    id: string
    inputKey?: string
    value?: number
    defaultValue?: number
    integer?: boolean
    max?: number
    round?: boolean
    optional?: boolean
    disabled?: boolean
    onChange?: (value?: number, manualChange?: boolean) => void
}

export const PercentField = (props: Props) => {
    const { id, inputKey, value, defaultValue, integer, max, round, optional, disabled, onChange } = props

    const handleChange = (newValue?: TextOrNumber, manualChange?: boolean) => {
        onChange && onChange(newValue as O<number>, manualChange)
    }

    return (
        <InputGroup
            id={id}
            inputKey={inputKey}
            value={value}
            defaultValue={defaultValue}
            postLabel="%"
            min={0}
            max={max}
            integer={integer}
            round={round}
            optional={optional}
            disabled={disabled}
            fit={true}
            className={styles.field}
            onChange={handleChange}
        />
    )
}
